import classNames from "classnames";
import { PropsWithChildren } from "react";

type TabButtonProps = {
  active: boolean;
  text: string;
  onClick: () => void;
};

export const ComplaintsTabButton: React.FC<
  PropsWithChildren<TabButtonProps>
> = ({ active, children, text, onClick }) => {
  return (
    <div
      className={classNames(
        "rounded-lg border border-primary flex flex-col items-center py-2 w-[100px] cursor-pointer text-gray-700",
        {
          "bg-white hover:bg-gray-100": !active,
          "bg-primary": active,
        },
      )}
      onClick={active ? undefined : onClick}
    >
      <span
        className={classNames("text-sm", { "text-primary-contrast": active })}
      >
        {text}
      </span>
      <div>{children}</div>
    </div>
  );
};
